import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type ImportTvTimeMutationVariables = Types.Exact<{
	file: Types.Scalars['Upload']['input'];
	readOnly: Types.Scalars['Boolean']['input'];
}>;

export type ImportTvTimeMutation = {
	__typename?: 'Mutation';
	importTVTimeLists: {
		__typename?: 'ImportTVTimePayload';
		watchlistMatched: number;
		watchlistAdded: number;
		seenlistMatched: number;
		seenlistAdded: number;
	};
};

export const ImportTvTimeDocument = gql`
	mutation ImportTVTime($file: Upload!, $readOnly: Boolean!) {
		importTVTimeLists(input: { file: $file, readOnly: $readOnly }) {
			watchlistMatched
			watchlistAdded
			seenlistMatched
			seenlistAdded
		}
	}
`;
